import { InformationPopupPage } from '../../shared/components/information-popup/information-popup.model';

export const initInformationPopupState: InformationPopupState = {
  pageSettings: [
    {
      page: InformationPopupPage.BackupAndRestore,
      showExpanded: true,
    },
    {
      page: InformationPopupPage.ExtendedParameters,
      showExpanded: true,
    },
    {
      page: InformationPopupPage.GuidedTroubleshooting,
      showExpanded: true,
    },
    {
      page: InformationPopupPage.HydraulicSchemes,
      showExpanded: true,
    },
    {
      page: InformationPopupPage.Snapshot,
      showExpanded: true,
    },
    {
      page: InformationPopupPage.RemoteServiceAnomalies,
      showExpanded: true,
    },
    {
      page: InformationPopupPage.RemoteServiceDiagnosis,
      showExpanded: true,
    },
    {
      page: InformationPopupPage.RemoteServiceFeatures,
      showExpanded: true,
    },
    {
      page: InformationPopupPage.RemoteServiceReport,
      showExpanded: true,
    },
  ],
  loading: false,
  loaded: false,
  error: null,
};

export interface InformationPopupState {
  pageSettings: UserPageSettings[];
  loading: boolean;
  loaded: boolean;
  error: any;
}

export interface UserPageSettings {
  page: InformationPopupPage;
  showExpanded: boolean;
}
